/**
 * Retrieves a value from the local storage by the given key.
 *
 * @param key - The key of the item to retrieve from local storage.
 * @returns The value associated with the key, or null if the key does not exist or local storage is not available.
 */
export const getLocalStorageValue = (key: string): string | null => {
  if (typeof window !== 'undefined' && typeof localStorage !== 'undefined' && localStorage.getItem(key) !== null) {
    return localStorage.getItem(key);
  }
  return null;
};
